<template>
    <!-- 能耗管理系统 -->
    <div id="tab5" class="img-show">
        <div class="white-bg">
            <div class="page-width main-content">
                <!-- 系统架构 -->
                <div>
                    <div class="sub-title">
                        <p>能源管理系统</p>
                    </div>
                    <div class="intro">
                        能源管理系统作为信息管理层的主要部分，基于100/1000M
                        自适应以太通讯网络（ETHERNET）网络构架，实现能源系统数据的收集、数据后台分析、数据查询、数据归档存储、数据挖掘、数据接口开放等功能。整个能源管理系统在软件应用架构上可分为集成层、应用层、展示层。
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/energy/功能架构.png"
                        alt="功能架构"
                        class="app-img system-jiagou"
                    />
                    <img
                        src="../../../../../assets/img/softProduct/energy/系统架构.jpg"
                        alt="系统架构"
                        class="app-img energy-jiagou"
                    />
                </div>
                <!-- 集成接口 -->
                <div>
                    <div class="sub-title">
                        <p>集成接口</p>
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/energy/集成接口2.png"
                        alt="集成接口"
                        class="app-img system-jiagou"
                    />
                </div>
                <!-- 技术优势 -->
                <div>
                    <div class="sub-title">
                        <p>技术优势</p>
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/energy/技术优势.png"
                        alt="技术优势"
                        class="app-img system-jiagou"
                    />
                </div>
                <div class="sub-title">
                    <p>系统功能</p>
                </div>
            </div>
        </div>
        <div class="grey-bg">
            <div class="page-width main-content">
                <!-- 系统功能 -->
                <div class="system-function ksh-function energy-function">
                    <div class="flex card-page flex-wrap">
                        <div class="card-text">
                            <p class="p1">能源设备管理</p>
                            <p class="p2">
                                建立能源设备、计量器具台账管理和调教管理功能，实现主要用能设备和计量仪表在线管理。
                            </p>
                        </div>
                        <img
                            src="../../../../../assets/img/softProduct/energy/能源设备管理.png"
                            alt=""
                            class="app-img"
                        />
                    </div>
                    <div class="flex card-page flex-wrap flex-end">
                        <img
                            src="../../../../../assets/img/softProduct/energy/能源集成监控.png"
                            alt=""
                            class="app-img"
                        />
                        <div class="card-text">
                            <p class="p1">能源集成监控</p>
                            <p class="p2">
                                能源数据集成和能源监控，是能源管理系统的基础部分。对各类介质能耗情况进行实时监控，实现可视化、数字化展示，帮助使用者直观的了解能耗情况，从而制定更合理的能源使用计划，提高能源利用率。
                            </p>
                        </div>
                    </div>
                    <div class="flex card-page flex-wrap">
                        <div class="card-text">
                            <p class="p1">能源异常管理</p>
                            <p class="p2">
                                对能源异常信息，按严重程度进行分级、按异常信息分类进行记录和归档。
                            </p>
                        </div>
                        <img
                            src="../../../../../assets/img/softProduct/energy/能源异常管理.png"
                            alt=""
                            class="app-img"
                        />
                    </div>
                    <div class="flex card-page flex-wrap flex-end">
                        <img
                            src="../../../../../assets/img/softProduct/energy/能源效率管理.png"
                            alt=""
                            class="app-img"
                        />
                        <div class="card-text">
                            <p class="p1">能源效率管理</p>
                            <p class="p2">
                                基于对各部门能源消耗数据的采集和统计，依据定额分解指标，实现对各部门能耗绩效的考核。
                            </p>
                        </div>
                    </div>
                    <div class="flex card-page flex-wrap">
                        <div class="card-text">
                            <p class="p1">能源数据查询</p>
                            <p class="p2">
                                基于能源计量数据，以多种条件组合检索查询能源数据，并支持导出查询结果。
                            </p>
                        </div>
                        <img
                            src="../../../../../assets/img/softProduct/energy/能源数据查询.png"
                            alt=""
                            class="app-img"
                        />
                    </div>
                    <div class="flex card-page flex-wrap flex-end">
                        <img
                            src="../../../../../assets/img/softProduct/energy/能源流向.png"
                            alt=""
                            class="app-img"
                        />
                        <div class="card-text">
                            <p class="p1">能源流向</p>
                            <p class="p2">
                                对各类能源流向情况进行展示，清晰并动态呈现能源流向路径及各节点相应能耗量。
                            </p>
                        </div>
                    </div>
                    <div class="flex card-page flex-wrap">
                        <div class="card-text">
                            <p class="p1">能源统计分析</p>
                            <p class="p2">
                                系统以报表和图表方式从不同角度分析能耗情况,包含能耗总量统计、
                                能源统计报表、能源趋势分析等功能。
                            </p>
                        </div>
                        <img
                            src="../../../../../assets/img/softProduct/energy/能源统计分析.png"
                            alt=""
                            class="app-img"
                        />
                    </div>
                    <div class="flex card-page flex-wrap flex-end">
                        <img
                            src="../../../../../assets/img/softProduct/energy/能源对比分析.png"
                            alt=""
                            class="app-img"
                        />
                        <div class="card-text">
                            <p class="p1">能源对比分析</p>
                            <p class="p2">
                                各类介质能耗量、能耗费用等的对比分析。
                            </p>
                        </div>
                    </div>
                    <div class="flex card-page flex-wrap">
                        <div class="card-text">
                            <p class="p1">能效分析</p>
                            <p class="p2">
                                分析能效指标项；分析能源投入、转换、分配、使用过程中的能源平衡；以国标、行标、企业标准对标分析。
                            </p>
                        </div>
                        <img
                            src="../../../../../assets/img/softProduct/energy/能效分析.png"
                            alt=""
                            class="app-img"
                        />
                    </div>
                </div>
                <div class="img-bottom"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>
<style scoped lang="less">
@import './softProduct.less';
</style>
